import { useCallback, useEffect, useState } from "react";
import { useContextSite } from "../../../context/Context";
import { useSessionStorage } from "../../../hooks/useSessionStorage";
import { useNavigate } from "react-router-dom";
import { RolesEnum } from "../../../enums/roles";
import { IAgendamentoDTO } from "../../../types/agendamento";
import { Agendamento } from "../../../services/Agendamento";
import { toast } from "react-toastify";
import { Usuario } from "../../../services/Usuario";
import { IMotivoDTO } from "../../../types/motivo";
import { Motivo } from "../../../services/Motivo";
import { TipoMotivoEnum } from "../../../enums/motivo";

export const useButtonOptions = () => {
  const { setIsLoad } = useContextSite();
  const [isOpen, setISOpen] = useState(false);
  const [usuario, setUsuario] = useSessionStorage("@usuarioMapa");
  const navigate = useNavigate();
  const [motivos, setMotivos] = useState<IMotivoDTO>({} as IMotivoDTO);
  const [recursos, setRecursos] = useState<string[]>([]);

  const getMotivos = useCallback(() => {
    Motivo.list({ tipo: TipoMotivoEnum.REEMBOLSO })
      .then(({ data }) => {
        const Motivo = data?.content?.filter((m) => m.descricao === "Outro")[0];
        setMotivos(Motivo);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      );
  }, []);

  const isIntern = !usuario?.roles?.some(
    (regra) => regra === RolesEnum.ROLE_CLIENTE
  );

  useEffect(() => {
    getMotivos();
    Usuario.getRecursosByUuid({ uuid: usuario?.uuidUsuario })
      .then(({ data }) => {
        setRecursos(data);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      );
  }, []);

  async function handleCancel(agendamento: IAgendamentoDTO) {
    setIsLoad(true);
    Agendamento.cancelar({ uuid: agendamento?.uuid })
      .then(({ data }) => {
        console.log("data", data);
        if (data?.encaminharFormulario) {
          navigate(
            `/agendamento/${agendamento?.uuid}/pagamento/formulario-reembolso`
          );
          return;
        }
        if (data?.confirmarReembosloPix) {
          navigate(`/agendamento/pagamento/cancelamento-pix`);
          return;
        }
        toast.success("Agendamento cancelado com sucesso");
        setTimeout(() => {
          navigate(`/meus-agendamentos/agendamento?id=${agendamento?.uuid}`);
        }, 1500);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      )
      .finally(() => {
        setIsLoad(false);
        setISOpen(false);
      });
  }

  return {
    isIntern,
    navigate,
    isOpen,
    setISOpen,
    setIsLoad,
    sessionAgendamento: usuario,
    setSessionagendamento: setUsuario,
    handleCancel,
    usuario,
    recursos,
  };
};
